module.exports = __webpack_public_path__ + "static/media/logo_pharmgenetix_einzeilig.8ef1ad04.svg";